import React from "react";
import { Button, Container, Row, Col, Form, Modal } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from '../AppContext';
import OrgDetails from "./OrgDetails";
import SearchScreen from "./SearchScreen";

export default class Organizations extends SearchScreen {
    pathPrefix = "/orgs";
    methodName = "Professional.search";
    addEnabled = true;
    detailComponent = OrgDetails;
    addParams = {};

    closeModal() { 
        this.extraElement = null;
        this.setState({ addItemData: {} }); 
    }

    async createOrg() {
        let itemData = await context.makeRequest("Professional.saveOrganization", this.state.addItemData);
        if (!itemData.error) {
            //alert("Saved");
            this.extraElement = null;
            context.navigate(this.pathPrefix + "/" + itemData.result.uuid, "Organization " + itemData.result.name)
        } else {
            alert("Error: " + itemData.error.message );
            this.refreshPushed();
        }
    }

    addPushed() {
        this.extraElement = (
            <Modal
                onHide={ () => this.closeModal() }
                centered={ true }
                backdrop={ 'static' } show={true}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Organization</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Name</Form.Label>
                        <Form.Control 
                            type="text"
                            value={ this.state.addItemData?.name }
                            onChange={ (event) => this.setState({ addItemData: { ...this.state.addItemData, name: event.target.value } }) }
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Email</Form.Label>
                        <Form.Control 
                            type="text"
                            value={ this.state.addItemData?.email }
                            onChange={ (event) => this.setState({ addItemData: { ...this.state.addItemData, email: event.target.value } }) }
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Country</Form.Label>
                        <Form.Control 
                            type="text"
                            value={ this.state.addItemData?.country }
                            onChange={ (event) => this.setState({ addItemData: { ...this.state.addItemData, country: event.target.value } }) }
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>City</Form.Label>
                        <Form.Control 
                            type="text"
                            value={ this.state.addItemData?.city }
                            onChange={ (event) => this.setState({ addItemData: { ...this.state.addItemData, city: event.target.value } }) }
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Address</Form.Label>
                        <Form.Control 
                            type="text"
                            value={ this.state.addItemData?.address }
                            onChange={ (event) => this.setState({ addItemData: { ...this.state.addItemData, address: event.target.value } }) }
                        />
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary"
                        onClick={ () => this.closeModal() }
                    >Close</Button>
                    <Button variant="primary"
                        onClick={ () => this.createOrg() }
                    >Save changes</Button>
                </Modal.Footer>
            </Modal>
        );
        this.setState({ addItemData: {} });
    }

    itemRenderer(item) {
        return (
            <ListGroup.Item action 
                key={item.uuid} 
                onClick={ () => context.navigate(this.pathPrefix + "/" + item.uuid, "Organization " + item.name) }
                className="listItem"
            >
                <div style={{ float: "left", flexDirection: 'row', flex: 1 }} key={"org_left_col_" + item.serverId} >
                    <div>{ item.name || item.firstName }</div>
                    <div>{ item.email } / { item.phone } / { item.address }</div>
                </div>
                <div style={{ float: "right", marginRight: "20px" }} key={"org_right_col_" + item.uuid} >
                    <div style={{ fontSize: 12 }}>{ item.owner ? item.owner.email : "Not owned" }</div>
                    <div style={{ fontSize: 12 }}>{ item.uuid }</div>
                </div>
            </ListGroup.Item> 
        )
    }
}